import { render, staticRenderFns } from "./rubric_preview_tables.vue?vue&type=template&id=49a48b58&scoped=true&"
import script from "./rubric_preview_tables.vue?vue&type=script&lang=js&"
export * from "./rubric_preview_tables.vue?vue&type=script&lang=js&"
import style0 from "./rubric_preview_tables.vue?vue&type=style&index=0&id=49a48b58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a48b58",
  null
  
)

export default component.exports